import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ContactDetails } from '../../../models/contact-details/contact-details.model';
import { ContactDetailsSerializer } from '../../../models/contact-details/contact-details-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class ContactDetailsService extends BaseApiService<ContactDetails> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "contactdetails", 
        new ContactDetailsSerializer(), 
        new CustomErrorHandlerService());
  }
}
